import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-alarm",
  "use": "icon-alarm-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-labelledby=\"alarmIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-alarm\"> <title id=\"icon-alarm_alarmIconTitle\">Alarm</title> <circle cx=\"12\" cy=\"13\" r=\"9\" /> <polyline points=\"12 8 12 13 15 16\" /> <path d=\"M19 2L22 5M2 5L5 2\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol